import React from 'react'
import {
  Icon,
  Message
} from 'semantic-ui-react'
import { format } from 'date-fns'
// Local
import { Encounter } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'
import ReveleerCoachingBox from '../../ReveleerCoachingBox'
import If from '../../common/if'

type Props = {
  encounter?: Encounter | undefined
}

function EncounterDateWarning(
  props: Props
): JSX.Element | null {
  const {
    encounter
  } = props

  const previousEncounter = (
    startDt: number | Date | undefined | null
  ): boolean => {
    if (!startDt) return false
    const today = format(new Date(), 'YYYYMMDD')
    const start = format(startDt, 'YYYYMMDD')
    return start < today
  }

  const futureEncounter = (
    startDt: number | Date | undefined | null
  ): boolean => {
    if (!startDt) return false
    const today = format(new Date(), 'YYYYMMDD')
    const start = format(startDt, 'YYYYMMDD')
    return start > today
  }

  if (encounter && encounter.start) {
    if (previousEncounter(encounter.start)) {
      return (
        <>
          <If isTrue={ !shouldRenderReskin2025 }>
            <Message warning>
              <Icon name="warning circle" />
              Please note: you are viewing a past encounter for this patient
            </Message>
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerCoachingBox
              coachingBoxType="infoNegative"
              isShowing
              message={
                <p>
                Please note: you are viewing a past encounter for this patient
                </p>
              } />
          </If>
        </>
      )
    }
    if (futureEncounter(encounter.start)) {
      return (
        <>
          <If isTrue={ !shouldRenderReskin2025 }>
            <Message warning>
              <Icon name="warning circle" />
              Please note: you are viewing a future encounter for this patient
            </Message>
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerCoachingBox
              coachingBoxType="infoNegative"
              isShowing
              message={
                <p>
                  Please note: you are viewing a future encounter for this patient
                </p>
              }
            />
          </If>
        </>
      )
    }
  }
  return null
}

export default EncounterDateWarning
